export const NAME = 'loginLine';